import React, { useState, useEffect, useRef } from 'react';
import './ProfileModal.css';
import profileAv from '../../../images/icons/profileAv2x.png';
import iconProfile from '../../../images/icons/iconProfile.svg';
import no_lock from '../../../images/icons/no_lock.svg';
import logOut from '../../../images/icons/logOut.svg';
import Logout from '../Logout/Logout';
import { navigate } from 'gatsby';

const ProfileModal = ({ show, setShow }) => {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem('userData'))
  );
  const myref = useRef(null);
  const closeOnClickOutside = (e) => {
    if (myref.current && myref.current.contains(e.target)) {
      return;
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeOnClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', closeOnClickOutside, true);
    };
  }, []);

  return (
    <React.Fragment>
      {/* <BackDrop show={show} clicked={() => setShow(false)} /> */}
      <div
        ref={myref}
        className={
          (show ? 'flex flex-col ' : 'hidden ') +
          'profile absolute w-56  h-72 bg-white rounded '
        }
      >
        <div className="flex flex-col justify-center items-center mt-4 pt-px">
          <div className="w-10 h-10 mb-4">
            <img src={profileAv} alt="img" />
          </div>
          <div>
            <p className="font-medium font-roboto text-base text-black-1000 text-right truncate">
              {userData?.name
                ? (
                    userData?.name?.firstName +
                    ' ' +
                    userData?.name?.lastName
                  ).substring(0, 15)
                : 'NA'}
            </p>
          </div>
          <div>
            <p className="text-grey-996 font-roboto text-xs font-normal truncate">
              {userData?.email || 'NA'}
            </p>
          </div>
          <div>
            <p className="text-grey-996 font-roboto text-xs font-normal truncate">
              {userData?.phone || 'NA'}
            </p>
          </div>
        </div>
        <hr className="w-5/6 mx-auto mt-3 text-white text-grey-997 " />
        <div className="flex flex-col justify-start items-start ml-4 pl-0.5">
          <div className="inline-flex mt-4 pt-px cursor-pointer">
            <div>
              <img src={iconProfile} alt="profile" />
            </div>
            <div>
              <p className="text-grey-998 ml-3 font-roboto font-normal text-sm">
                Profile
              </p>
            </div>
          </div>
          <div
            className="inline-flex mt-4 pt-px cursor-pointer"
            onClick={() => navigate('/user/changepassword')}
          >
            <div>
              <img src={no_lock} alt="no_lock" />
            </div>
            <div>
              <p className="text-grey-998 ml-3 font-roboto font-normal text-sm">
                Change Password
              </p>
            </div>
          </div>
          <div
            className="inline-flex mt-4 pt-px cursor-pointer"
            onClick={Logout}
          >
            <div>
              <img src={logOut} alt="profile" />
            </div>
            <div>
              <p className="text-grey-998 ml-3 font-roboto font-normal text-sm">
                Logout
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProfileModal;
